throw new Error("[patchstack] this module is Node-only and unavailable on an edge runtime");